export default "__VITE_ASSET__C3dWZZp___"